import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/brand/logo-white.png")